module.exports = __webpack_public_path__ + "staticcomp/img/top.b02d2b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/9/top.jpg
// module id = nK7f
// module chunks = 39